import React from 'react';
import SVG from 'react-inlinesvg';
import Icon from '@ant-design/icons';
import './MessageIcon.scss';

export interface MessageIcon {
  svgUrl: string;
  className?: string;
}

export function MessageIcon(props: MessageIcon) {
  return (
    <Icon
      className={props?.className}
      component={(iProps) => <SVG src={props.svgUrl} {...iProps} />}
    />
  );
}
